import { HStack, Text } from "@chakra-ui/react";
import { cloneElement } from "react";
import { useHistory } from "react-router-dom";
import { translation as t } from "../../data/locale";
import { MembershipIcon } from "../Icons";
function DonationButton() {
  const history = useHistory();

  return (
    <HStack
      sx={{
        display: "flex",
        alignItems: "center",
        px: "3",
        gap: "4px",
        py: "2",
        bg: "white",
        color: "black",
        borderRadius: "200px",
        cursor: "pointer",
        pe: "8",
      }}
      shadow="md"
      onClick={() => history.push("/e-services/membership")}
    >
      {cloneElement(<MembershipIcon />, {
        color: "brand.500",
        boxSize: "20",
        width: "54px",
        height: "54px",
        borderRadius: "50",
      })}
      <Text
        sx={{
          fontSize: "17px",
          fontWeight: "bold",
        }}
      >
        {t.fast_donate}
      </Text>
    </HStack>
  );
}

export default DonationButton;
